import { useState, useEffect } from "react"
import { useUpdateQuestionSetMutation, useDeleteQuestionSetMutation, useGenerateQuestionSetForUsersMutation } from "./questionSetsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"

import 'react-quill/dist/quill.snow.css'; // import the styles
import TimeLeft from "../../partial/TimeLeft"

const GenerateQuestionSetToUsersForm = ({ questionSet, groups }) => {
    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [generateQustionsetForUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useGenerateQuestionSetForUsersMutation()


    const navigate = useNavigate()

    const [title, setTitle] = useState(questionSet?.title +"-"+ new Date().toLocaleDateString() );
    const [group, setGroup] = useState(groupId!='0'?groupId:'' );
    const [minimumPassed, setMinimumPassed] = useState(
      questionSet?.minimumPassed
    );
    const [fromDate, setFromDate] = useState(new Date())
    const [toDate, setToDate] =useState(new Date(new Date().getTime() + 45*60000))
    const [allowBack, setAllowBack] = useState(false)
    const [showResults, setShowResults] = useState(false)
    const [incluedInGrade, setIncluedInGrade] = useState(true)
    const [ratio, setRatio] = useState(0)




    useEffect(() => {

        if (isSuccess) {
            setTitle("");
            setMinimumPassed(0);
            navigate(`/${type}/${groupId}/question-sets/${questionSet._id}/final`);
        }

    }, [isSuccess, navigate])

  
    const canSave =[title, group, fromDate, toDate].every(Boolean) && !isLoading;

    const onSaveQuestionSetClicked = async (e) => {
        if (canSave) {
            await generateQustionsetForUser({
                id:questionSet.id,
                title,
                minimumPassed,
                fromDate,
                toDate,
                group,
                allowBack,
                showResults,ratio, incluedInGrade
              })
        }
    }

  

   
    const options = groups.map((group) => {
        return (
          <option key={group.id} value={group.id}>
            {" "}
            {group.name}
          </option>
        );
      });


    const errClass = (isError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message ) ?? ''




    const content = (
        <>
            <p className={errClass}>{errContent}</p>
            <p className="offscreen">
                לידעתך,
                לא ניתן לערוך את השאלון  למשתמשים לאחר שנוצרה גרסה
                <br />
                בנוסף במידה ומשתמש אחד ענה על שאלון הגרסה לא יהא ניתן למוחקו
                <br />
                קיימת אפשרות לבצע אותו לא פעיל ואז המשתמשים לא יוכלו לענות עליו יותר
            </p>
            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>גרסת שאלון למשתמשים</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to QuestionSet"
                            onClick={()=>{navigate(`/${type}/${groupId}/question-sets`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>              
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveQuestionSetClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                       
                    </div>
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="title">
          Title:
        </label>
        <input
          className={`form__input  ${!title && "form__input--incomplete"}`}
          id="title"
          maxLength={100}
          name="title"
          type="text"
          autoComplete="off"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

<div className="form-input-container">
                 <label className="form__label" htmlFor="fromDate">
                    From Date:</label>
                    <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                 <div className="form-input-container">
                 <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="group">
                    GROUP:</label>
                <select
                    id="group"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>setGroup(e.target.value)}
                >
                    <option></option>
                    {options}
                </select>
                    </div>

    <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>

       
                   
                    
                      

                </div>
              
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ALLOW BACK:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={allowBack}
                        onChange={(e)=>setAllowBack(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-showResults">
                   SHOW RESULTS:
                    <input
                        className="form__checkbox"
                        id="user-showResults"
                        name="user-showResults"
                        type="checkbox"
                        checked={showResults}
                        onChange={(e)=>setShowResults(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
               
            </form>
           
          
        </>
    )

    return content
}

export default GenerateQuestionSetToUsersForm